import axios from 'axios';

export const userStockifyApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND}api/users-stk`,
    headers: {
        'Content-Type': 'application/json'
    }
})